/// \file routes.tsx
///
/// \par Copyright Notice:
/// Copyright (c) 2023 by Oshkosh Corporation.
/// All Rights Reserved.
///
/// \par
/// The information contained herein is confidential and proprietary property
/// of Oshkosh Corporation, and may be privileged.  The dissemination,
/// distribution, use, copying, transfer, or disclosure of such information is
/// strictly prohibited except by express written agreement with Oshkosh
/// Corporation, or with one of its subsidiaries.

import {lazy, Suspense} from "react";
import { ActionFunctionArgs, LoaderFunctionArgs, Route } from "react-router-dom";

import NotFoundPage from "../views/notFoundPage";
import Layout from "../components/layouts/mainLayout";

import authRoutes from './authRoutes'
import adminRoutes from './adminRoutes'
import fleetRoutes from './fleetRoutes'
import accountSubscriptions from "./accountSubscriptions";
import releaseNotes from "./releaseNotes";
import accountRoutes from "./accountRoutes";
import systemNotifications from "./systemNotifications";
import securityRoutes from "./securityRoutes";
const HomeList = lazy(() => import('../views/home/list/view'));

async function homeDataLoader(args: LoaderFunctionArgs) {
  const actualLoader = (await import('../views/home/list/loader')).default;
  return actualLoader(args);
}

export async function homeAction(args: ActionFunctionArgs) {
  const actualAction = (await import("../views/home/list/action")).action;
  return actualAction(args);
}

const routes = (
  <Route
    path='/'
    element={ <Layout/> }
    errorElement={ <NotFoundPage/> }
    handle={{
      text: 'Home'
    }}
    >
    <Route
      index
      element={
        <Suspense fallback={<div>Loading...</div>}>
          <HomeList />
        </Suspense>
      }
      loader={homeDataLoader}
      action={homeAction}
    />
    {authRoutes}
    {adminRoutes}
    {fleetRoutes}
    {accountSubscriptions}
    {releaseNotes}
    {accountRoutes}
    {systemNotifications}
    {securityRoutes}
    <Route path='*' element={ <NotFoundPage/> } />
  </Route>
);

export default routes;